module.exports = ":host .list-container {\n  padding: 0; }\n\n:host .about .sub-head {\n  color: white; }\n\n:host .about .title {\n  color: white; }\n\n:host .about .summary {\n  color: white; }\n\n:host .item-list {\n  display: block;\n  margin-top: 25px;\n  padding: 0; }\n  :host .item-list .text-box {\n    padding-left: 0; }\n\n:host ::ng-deep .tab-container {\n  border-bottom: 1px solid #4C4C4C; }\n  :host ::ng-deep .tab-container .tab p {\n    color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/tab-list/tab-list.style.scss
// module id = 830
// module chunks = 2